module.exports = __webpack_public_path__ + "img/step6.1ef9beb1.png";